import { tv } from "@ui/lib/tv";

/**
 * The two platform-native bottom-sheet presentations, sharing one surface:
 *
 * - **floating** (iOS alert style): 12px gutters that reveal the scrim, so the
 *   panel itself is transparent and its contents supply their own cards.
 * - **docked** (Material 3): edge-to-edge, 28px top radius, white fill.
 *
 * Bottom spacing uses the house safe-area utility — `max(inset, gap)`, never
 * `inset + gap`, which double-counts the home indicator.
 */
export const mobileSheet = tv({
  slots: {
    backdrop: "bg-black/40",
    panel: "bg-transparent",
  },
  variants: {
    presentation: {
      floating: {
        panel: "max-w-[480px] px-3 pb-safe-[0.75rem]",
      },
      docked: {
        backdrop: "bg-black/32",
        panel: "max-w-[640px] rounded-t-[28px] bg-white pb-safe-[0.5rem] shadow-sheet",
      },
    },
  },
});
